import WebflowPage from "../components/WebflowPage";
import useSeo from "../lib/useSeo";

export default function HowItWorks() {
  useSeo({
    title: "How Selling Gift Cards for Cash Works — GC Nexon",
    description: "Submit your card, get a rate, pass verification, get paid. Four simple steps to turn any unused gift card into cash in under 24 hours.",
    path: "/how-it-works",
  });
  return <WebflowPage htmlPath="/site/how-it-works.html" title="How it works — GC Nexon" />;
}
